// Componente que despliega y muestra la vista de confirmacion de cada metodo de pago

import React, { useEffect } from "react";
import ZelleConfirmation from "./viewConfimation/zelleConfirmation";
import PagoMovilConfirmation from "./viewConfimation/pagoMovilConfirmation";
import TarjetaCreditoConfirmation from "./viewConfimation/tarjetaCreditoConfirmation";
import CredicardConfirmation from "./viewConfimation/credicardConfirmation";
import BanescoConfirmation from "./viewConfimation/banescoConfirmation";
import VenezuelaConfirmation from "./viewConfimation/venezuelaConfirmation";
import MercantilConfirmation from "./viewConfimation/mercantilConfirmation";
import MercantilTDCConfirmation from "./viewConfimation/mercantilTDCConfirmation";

function Step5({ stespData, setStespData, deatils, stapsState, setStapsState }) {
  useEffect(() => {
  }, [stespData])
  return (
    <>
      {stespData?.metodoPago.title === "Zelle" && (
        <ZelleConfirmation
          stespData={stespData}
          setStespData={setStespData}
          stapsState={stapsState}
          setStapsState={setStapsState}
          deatils={deatils}
        />
      )}

      {stespData?.metodoPago.title === "Pago Móvil" && (
        <PagoMovilConfirmation
          stespData={stespData}
          setStespData={setStespData}
          stapsState={stapsState}
          setStapsState={setStapsState}
          deatils={deatils}
        />
      )}

      {stespData?.metodoPago.title === "Tarjeta Internacional" && (
        <TarjetaCreditoConfirmation
          stespData={stespData}
          setStespData={setStespData}
          stapsState={stapsState}
          setStapsState={setStapsState}
          deatils={deatils}
        />
      )}
      {stespData?.title === "Otros Bancos" && (
        <CredicardConfirmation
          stespData={stespData}
          setStespData={setStespData}
          stapsState={stapsState}
          setStapsState={setStapsState}
          deatils={deatils}
        />
      )}
      {stespData?.formSeleccione?.banco?.title === "Banco de Venezuela" && (
        <VenezuelaConfirmation
          stespData={stespData}
          setStespData={setStespData}
          stapsState={stapsState}
          setStapsState={setStapsState}
          deatils={deatils}
        />
      )}
      {stespData?.formSeleccione?.banco?.title === "Mercantil" && (
        <MercantilConfirmation
          stespData={stespData}
          setStespData={setStespData}
          stapsState={stapsState}
          setStapsState={setStapsState}
          deatils={deatils}
        />
      )}

      {stespData?.metodoPago.title === "Crédito Nacional" && (
        <MercantilTDCConfirmation
          stespData={stespData}
          setStespData={setStespData}
          stapsState={stapsState}
          setStapsState={setStapsState}
          deatils={deatils}
        />
      )}

      {stespData?.formSeleccione?.banco?.title === "Banesco" && (
        <BanescoConfirmation
          stespData={stespData}
          setStespData={setStespData}
          stapsState={stapsState}
          setStapsState={setStapsState}
          deatils={deatils}
        />
      )}
    </>
  );
}

export default Step5;
